export const CUSTOMER_LEVEL = {
  ROOT: 0,
  N1: 1,
  N2: 2,
} as const;
